var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.href === '' ? 'button' : 'a',{tag:"button",class:[
        {
            'cursor-pointer rounded-full uppercase': true,
            'py-2 px-4 text-sm border': _vm.isSmall,
            'py-4 px-8 text-lg border-2': _vm.isLarge,
            'py-3 px-6 border-2': !_vm.isSmall && !_vm.isLarge,
            'inline-block': _vm.href !== ''
        },
        _vm.buttonClasses
    ],attrs:{"href":_vm.href ? _vm.href : false,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"font-serif-medium"},[(_vm.icon)?_c('m-icon',{attrs:{"size":"13","stroke":"2","name":_vm.icon}}):_vm._e(),_vm._t("default")],2),(_vm.isLoading)?_c('span',{staticClass:"inline-block w-4 h-4 ml-2"},[_c('m-loading',{attrs:{"is-loading":_vm.isLoading}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }